export default __webpack_public_path__ + "static/media/906.a6378009.gif";